import React from 'react';

export default
<g id="icon/play/white" stroke="none" strokeWidth="1" fillRule="evenodd">
    <polygon id="Path_409" fillRule="nonzero" points="4 0 4 36 32.2856454 18.0004821"></polygon>
</g>;
